import React from "react";
import { useRecoilState } from "recoil";

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import { LOAC_LAYERS, loacLayerAtom } from './atoms'

export default function LoacLayerSelector() {
	const [loacLayer, setLoacLayer] = useRecoilState(loacLayerAtom)

  const updateLoacLayer = (e) => {
  	const layer = LOAC_LAYERS.find((l) => l.value === e.target.value)

  	if (layer) {
    	setLoacLayer(layer)
    }
  }

  const renderRadioButton = (l) => {
  	return (
  		<Radio
  			aria-label={l.label}
  			size="small" />
  	)
  }

	const renderRadioControl = (l) => (
		<FormControlLabel
			key={l.value}
			control={renderRadioButton(l)}
			value={l.value}
			label={l.label}
			sx={{
				width: "180px",
				marginBottom: -1,
			}}/>
	)

	return (
		<FormControl sx={{
			mb: 2,
			ml: 3,
		}}>
			<FormLabel
				id="loac-layer-select-label"
				sx={{
					fontSize: "11px",
					color: '#868b8e',
					marginBottom: '2px',
				}}>
				Layer
			</FormLabel>
			<RadioGroup
				row
				name="loac-layer-select"
				aria-labelledby="loac-layer-select-label"
				defaultValue={loacLayer.value}
				onChange={updateLoacLayer}>
				{LOAC_LAYERS.map((l) => renderRadioControl(l))}
			</RadioGroup>
		</FormControl>
	)
}